import type { CompanyUpdateInput } from "@/graphql/codegen/graphql"

export type UpdateVendorPayableFieldsInput = Pick<
  CompanyUpdateInput,
  "companyId" | "sensitiveAccount" | "defaultExpenseAccountId"
>

interface VendorPayableFieldsFormSlice {
  sensitiveAccount?: boolean | null
  defaultExpenseAccountId?: string | null
}

interface VendorPayableFieldsDirtyFlags {
  sensitiveAccount?: boolean
  defaultExpenseAccountId?: boolean
}

// Only dirty fields are sent — `undefined` means "keep existing value" on the BE,
// and an untouched sensitiveAccount must not trigger its permission check.
export const mapVendorPayableFieldsToUpdateInput = (
  values: VendorPayableFieldsFormSlice,
  dirtyFields: VendorPayableFieldsDirtyFlags,
  companyId: string
): UpdateVendorPayableFieldsInput => ({
  companyId,
  ...(dirtyFields.sensitiveAccount && { sensitiveAccount: values.sensitiveAccount ?? null }),
  ...(dirtyFields.defaultExpenseAccountId && { defaultExpenseAccountId: values.defaultExpenseAccountId ?? null }),
})
